<script>
    export default {}
</script>

<template>
    <div class="container">
        <div class="header"></div>
        <div class="battery"></div>
    </div>
</template>

<style scoped>
    .container {
        width: 12px;
        margin: auto;
        position: relative;
    }

    .header {
        top: 0;
        left: 50%;
        width: 4px;
        height: 2px;
        position: absolute;
        border-radius: 1px 1px 0 0;
        transform: translate(-50%, -2px);
        background: rgba(255, 255, 255, .88);
    }

    .battery {
        z-index: 1;
        height: 20px;
        position: relative;
        box-sizing: border-box;
        background-color: white;
        border-radius: 2px 2px 0 0;
    }

    .battery::after {
        left: 0;
        top: 80%;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        filter: hue-rotate(90deg);
        animation: charging 10s linear infinite;
        background: linear-gradient(to bottom, #70F570 0%, #49C628 44%, #009251 100%);
    }

    @keyframes charging {
        50% {

        }

        95% {
            top: 5%;
            filter: hue-rotate(0deg);
        }
        100% {
            top: 0;
            filter: hue-rotate(0deg);
        }
    }
</style>
